<template>
  <div>
    <b-row
      align-v="center"
    >
      <b-col class="p-0">
        <CheckBoxConfiguration
          :controller="DeltaFitGraphBool"
          :switchprop="true"
        />
      </b-col>
      <b-col
        v-if="DeltaFitGraphBool.value"
        class="m-0 p-0"
        cols="2"
      >
        <b-button
          size="sm"
          variant="outline-primary"
          class="m-0 p-0"
          @click="DeltaFitGraphExpanded=!DeltaFitGraphExpanded"
        >
          <b-icon
            v-if="DeltaFitGraphExpanded"
            aria-label="More"
            icon="caret-up"
          />
          <b-icon
            v-else
            aria-label="More"
            icon="caret-down"
          />
        </b-button>
      </b-col>
    </b-row>
    <b-row v-if="DeltaFitGraphBool.value">
      <b-collapse
        v-model="DeltaFitGraphExpanded"
        class="ml-5 mb-2 expanded-info p-1 pr-4"
      >
        <TextInputConfiguration
          :controller="X1DeltaCtrller"
          :sizeinput="'sm'"
          :forcerow="true"
        />
        <TextInputConfiguration
          :controller="X2DeltaCtrller"
          :sizeinput="'sm'"
          :forcerow="true"
        />
        <TextInputConfiguration
          :controller="MeanDeltaCtrller"
          :sizeinput="'sm'"
          :forcerow="true"
        />
        <CheckBoxConfiguration
          :controller="StandardAdditionCtrller"
          :switchprop="true"
        />
        <FitSelection
          :sectionconfig="sectionconfig"
          :fitname="fitName"
        />
        <StatisticalEvaluation
          :sectionconfig="sectionconfig"
          :fitname="fitName"
        />
      </b-collapse>
    </b-row>
  </div>
</template>

<script>
import CheckBoxConfiguration from '@/components/properties/elements/CheckBoxConfiguration'
import TextInputConfiguration from '@/components/properties/elements/TextInputConfiguration'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import {checkBoxGraphConfCtrller,inputTextConfCtrller} from '@/assets/classes/configuration.js'
import FitSelection from './model/FitSelection'
import StatisticalEvaluation from './StatisticalEvaluation'
import { mapGetters } from 'vuex'

const fitName = 'ΔY'
const rootContextFolder='ReportViewer/Fit/' + fitName

export default {
  name: 'DeltaFit',
  components:{
    FitSelection,
    StatisticalEvaluation,
    CheckBoxConfiguration,
    TextInputConfiguration
  },
  props: {
    sectionconfig:{
      type:String,
      required: true
    },
  },
  data() {
    return {
      fitName,
      elementsConfig:[],
      DeltaFitGraphBool:new checkBoxGraphConfCtrller(`{0}.${ConfigName.DeltaFitDiscreteGraph}`,'Delta Fit',false,rootContextFolder+'Enable',true),
      X1DeltaCtrller:new inputTextConfCtrller(`${ConfigName.BaseCurveFit}.${fitName}.X1`,'X1','Please give a numerical value','0',(value)=>{return !isNaN(value) && value!==''}),
      X2DeltaCtrller:new inputTextConfCtrller(`${ConfigName.BaseCurveFit}.${fitName}.X2`,'X2','Please give a numerical value','1',(value)=>{return !isNaN(value) && value!==''}),
      MeanDeltaCtrller:new inputTextConfCtrller(`${ConfigName.BaseCurveFit}.${fitName}.SamplesMean`,'Sample Mean','Please give a numerical value greater than zero','1',(value)=>{return !isNaN(value) && value>0}),
      StandardAdditionCtrller:new checkBoxGraphConfCtrller(`${ConfigName.BaseCurveFit}.${fitName}.StandardAddition`,'Standard Addition',false,rootContextFolder+'StandardAddition'),
			DeltaFitGraphExpanded:true,
    }
  },
  computed: mapGetters([
    'getCurrentReportViewer',
  ]),
  watch:{
    sectionconfig(){
      this.configureStudy()
    }
  },
  mounted(){
    this.elementsConfig = [
      this.DeltaFitGraphBool,
      this.X1DeltaCtrller,
      this.X2DeltaCtrller,
      this.MeanDeltaCtrller,
			this.StandardAdditionCtrller,
    ]
    this.configureStudy()
    this.$watch(
      'DeltaFitGraphBool.value',
      () => {
        this.verifyConfiguration()
      }
    );
  },
  methods:{
    configureStudy(){
      this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
      this.DeltaFitGraphBool.formatKeyValue(this.sectionconfig)
      this.DeltaFitGraphBool.setParent(this)
      this.verifyConfiguration()
    },
    verifyConfiguration(){
      if(this.DeltaFitGraphBool.value){
        this.elementsConfig.forEach(conf=>conf.setParent(this))
      }else if(
        typeof(this.getCurrentReportViewer.configuration[this.sectionconfig]) !== 'undefined'
        &&typeof(this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseCurveFit])!=='undefined'
        && typeof(this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseCurveFit][fitName])!=='undefined'
      ){
        delete this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseCurveFit][fitName]
      }
    }
  }
}
</script>

<style>

</style>